import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from "./FlowchartPaper_Interface"
import { ProductRequestDetail_Interface } from "./ProductRequestDetail_Interface"

export interface ProductRequest_Interface {
    id:number,
    dsc:String,

    visible:boolean,
    
    detail:Array<ProductRequestDetail_Interface>

    fullname:String,
    persianDate:String,
    status:number,
    totalPrice:number,
    flowchart:FlowchartPaper_Interface
}

export function Empty_ProductRequest_Interface():ProductRequest_Interface{
    return{
      id:0,
      dsc:'',
      visible:false,
      detail:[],

      fullname:'',
      persianDate:'',
      status:0,
      totalPrice:0,
      flowchart:Empty_FlowchartPaper_Interface()
    }
  }